"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function WhyFail() {
  const { t } = useLanguage();

  return (
    <section className="bg-[#fefce8] py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-[32px] font-bold text-[#064e3b] text-center mb-12">
          {t("sliding.whyFailH2")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-[1080px] mx-auto">
          <div>
            <h3 className="text-[22px] font-bold text-[#064e3b] mb-2">{t("sliding.whyFail1Title")}</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              {t("sliding.whyFail1Desc")}
            </p>
          </div>
          <div>
            <h3 className="text-[22px] font-bold text-[#064e3b] mb-2">{t("sliding.whyFail2Title")}</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              {t("sliding.whyFail2Desc")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}